export default __webpack_public_path__ + "static/uninsured-cc17b9f8c408a9bdf4f37885752dc9dd.png";